import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { fetchAPISlackBot, setQueryCache, updateAPISlackBot } from "@/utils"

export function useAPISlackBot() {
  const queryClient = useQueryClient()
  const update = useMutation({
    mutationFn: updateAPISlackBot,
    onSuccess: (data) => {
      queryClient.setQueryData(["slackbot"], (oldData: any) => {
        return {
          ...oldData,
          ...data,
        }
      })
    },
  })
  const query = useQuery({
    queryKey: ["slackbot"],
    queryFn: fetchAPISlackBot,
    ...setQueryCache(24 * 3600e3),
  })

  return {
    ...query,
    update: update.mutateAsync,
  }
}
